<template>
  <div class="contents">
    <md-card>
      <md-card-media>
        <img class="logo" src="@/assets/logo_diamondworks_optimized.png" alt="DiamondWorks">
      </md-card-media>

      <md-card-content>
        presented by DiamondWorks
      </md-card-content>
    </md-card>
    <md-card>
      <md-card-media>
        <img class="logo" src="@/assets/logo_optimized.png" alt="DiamondWorks">
      </md-card-media>
      <md-card-content>
        <div>ロゴは <a href="https://www.designevo.com/jp/logo-maker/" title="無料オンラインロゴメーカー">DesignEvo</a> ロゴメーカーさんで作成しました</div>
      </md-card-content>
    </md-card>
    <md-card>
      <InFeedAdsense
        data-ad-layout-key="-6t+ed+2i-1n-4w"
        data-ad-client="ca-pub-3855984555521591"
        data-ad-slot="9841916293">
      </InFeedAdsense>
    </md-card>
  </div>
</template>
<script>
export default {
  name: 'Credit',
  data () {
    return {
      imageFileList: []
    }
  },
  created: function () {
    // 画面タイトルを設定する(default)
    this.$emit('setTitle')
  },
  methods: {
    selectCanvas: function (selectNo) {
      this.debug('selectCanvas(' + selectNo + ')')
      // 特定の画像を選択
      this.$emit('selectCanvas', selectNo)
    },
    onClearCanvas: function () {
      this.debug('何もしない')
    },
    nextCanvas: function () {
      this.debug('何もしない')
    },
    beforeCanvas: function () {
      this.debug('何もしない')
    }
  }
}
</script>
<style lang="scss" scoped>
  .contents {
    width: 100%;
    height: 100%;
    // margin: 80px , 0px;
    // margin-top: 80px;
    margin-bottom: 80px;
    // padding-right: 80px;
    background-color: white;
    z-index:  1;
  }
  .md-card {
    width: 320px;
    margin: 4px;
    display: inline-block;
    vertical-align: top;
  }
</style>



// WEBPACK FOOTER //
// src/components/Credit.vue